export default "__VITE_ASSET__FY1wE4AR__"